import React from 'react'
import {
  IcoMoon,
  Box,
  PayPalFullIconWmo,
  GPayCheckoutLogoWmo,
  ApplePayLogoIconWmo,
} from '@usap/uicomponents'
import { useGPaySupported, usePlatformCheck  } from '@usap/core'

const CartExpressIconsWmo = () => {
  const isGPaySupport = useGPaySupported()
  const {isMobile, platform} = usePlatformCheck()

  return (
    <>
      <Box direction="row">
        <Box pad="0 15px">
          <IcoMoon icon={PayPalFullIconWmo} width="98px" height="28px" />
        </Box>
        {!(isMobile && platform === "android") && (
          <Box pad="0 15px">
            <IcoMoon icon={ApplePayLogoIconWmo} width="54px" height="25px" />
          </Box>
        )}
        {isGPaySupport && (
          <Box pad="0 15px">
          <IcoMoon icon={GPayCheckoutLogoWmo} width="55px" height="23px" />
        </Box>
        )}
      </Box>
    </>
  )
}

export default CartExpressIconsWmo
